// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const fontSizes = {
    100: "0.6399999856948853em",
    200: "0.6600000262260437em",
    300: "0.7229999899864197em",
    400: "0.800000011920929em",
    500: "0.824999988079071em",
    600: "0.902999997138977em",
    700: "1em",
    800: "1.031000018119812em",
    900: "1.128999948501587em",
    1000: "1.25em",
    1100: "1.2879999876022339em",
    1200: "1.4110000133514404em",
    1300: "1.562999963760376em",
    1400: "1.6109999418258667em",
    1500: "1.7640000581741333em",
    1600: "1.9529999494552612em",
    1700: "2.013000011444092em",
    1800: "2.2049999237060547em",
    1900: "2.440999984741211em",
    2000: "2.5169999599456787em",
    2100: "2.75600004196167em",
    2200: "3.052000045776367em",
    2300: "3.1459999084472656em",
    productMicrocopy: "0.800000011920929em",
    productDisclosure: "0.903124988079071em",
    productCaption: "0.903124988079071em",
    productBody: "1em",
    productH3: "1.128749966621399em",
    productH2: "1.4112499952316284em",
    productH1: "1.7625000476837158em",
    brandMicrocopy: "0.800000011920929em",
    brandDisclosure: "0.903124988079071em",
    brandCaption: "0.903124988079071em",
    brandBody: "1em",
    brandH4: "1.128749966621399em",
    brandH3: "1.5631250143051147em",
    brandH2: "2.2049999237060547em",
    brandH1: "2.7562499046325684em",
    root: "1em",
};
module.exports = fontSizes;
//# sourceMappingURL=fontSizes.js.map